module.exports = __webpack_public_path__ + "img/55555555555-283x400.c17f565b.jpg";